export enum SetupStoreId {
  Category = 'cate-store',
  App = 'app-store',
  Theme = 'theme-store',
  Auth = 'auth-store',
  Route = 'route-store',
  Tab = 'tab-store',
  Client = 'client-store',
  Product = 'product-store',
  Device = 'device-store',
  Mock = 'mock-store',
  DataCenter = 'data-center-store',
  LayoutFoot = 'layout-foot-store',
  System = 'system-store',
  SearchCache = 'search-cache-store',
  Application = 'application-store'
}
